export const ensureType = <T>(value: T) => value
